import loadable from '@loadable/component'

const FeaturePage = loadable(() => import('./Feature'))
const HomePage = loadable(() => import('./Home'))
const PricingPage = loadable(() => import('./Pricing'))
const UseCasePage = loadable(() => import('./UseCase'))
const ChatSDKCommunity = loadable(() => import('./ChatSDKCommunity'))

export { ChatSDKCommunity, FeaturePage, HomePage, PricingPage, UseCasePage }
